import { Skeleton } from 'antd';
import React, { useCallback } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useGetAllActiveSearchTagsQuery } from '../../MvpAdmin/slices/searchTagsSlice';

function SearchFilterCard({ imageSrc, name, active = false, onClick }) {
  return (
    <div
      className={
        'slider-content search-filter-card cp ' +
        (active ? 'search-filter-card--active' : 'search-filter-card--inactive')
      }
      onClick={onClick}
    >
      <div className='search-filter-card__image brFull mg-bottom-8'>
        <img src={imageSrc} alt={name} />
      </div>
      <p className='sb-blue-600 fs-12 gSemiBold w-full txt-center mg-bottom-0'>
        {name}
      </p>
    </div>
  );
}

function SkeletonSearchFilterCard() {
  return (
    <div className='slider-content search-filter-card cp '>
      <div className='search-filter-card__image mg-bottom-8'>
        <Skeleton.Avatar
          active
          className={'w-full h-full'}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      <p className='fs-12 w-full txt-center mg-bottom-0'>
        <Skeleton active size={'small'} paragraph={false} />
      </p>
    </div>
  );
}

function MapQuickFilters({ selected = [], onSelectionChange }) {
  let { data: activeQuickFilters, isFetching: loadingFilters } =
    useGetAllActiveSearchTagsQuery();

  const handleFilterClick = useCallback(
    (key) => {
      const wasAlreadySelected = selected.includes(key);
      onSelectionChange(
        wasAlreadySelected
          ? selected.filter((s) => s !== key)
          : [...selected, key]
      );
    },
    [onSelectionChange, selected]
  );

  return (
    <Splide
      hasTrack={false}
      aria-label='quick search filters'
      className='search-quick-filters'
      options={{
        autoWidth: true,
        perMove: 1,
        waitForTransition: false,
        arrows: true,
        pagination: false,
        gap: '0.5rem',
        wheel: true,
        wheelSleep: 20,
        direction: 'ltr',
        omitEnd: true,
      }}
    >
      <SplideTrack>
        {loadingFilters ? (
          <div className='display-flex-row justify-start gap-1r'>
            {Array.from(Array(8)).map((_, i) => (
              <SkeletonSearchFilterCard key={`search-skeleton-${i}`} />
            ))}
          </div>
        ) : (
          (activeQuickFilters ?? []).map((filter) => (
            <SplideSlide key={`search-filter-${filter.id}`}>
              <SearchFilterCard
                name={filter.label}
                imageSrc={filter.icon}
                active={selected.includes(filter.id)}
                onClick={() => handleFilterClick(filter.id)}
              />
            </SplideSlide>
          ))
        )}
      </SplideTrack>
      <div className='splide__arrows' />
    </Splide>
  );
}

export default MapQuickFilters;
